<!--<div @fadeIn *ngIf="loading">-->
<!--  <mat-form-field appearance="outline">-->
<!--    <mat-label>Loading ...</mat-label>-->
<!--    <input matInput disabled>-->
<!--    <mat-spinner matSuffix [diameter]="18"-->
<!--                 style="float: right; margin-left: 8px"></mat-spinner>-->
<!--  </mat-form-field>-->
<!--</div>-->


<!--<div @fadeIn *ngIf="!loading" class="w-100 border-l border-t border-b border-r border-black rounded flex flex-row">-->
<!--  <div class="min-w-[145px] hover:!bg-[#f3fbff] rounded">-->
<!--    <div class="flex flex-1 p-3">-->
<!--      <mat-select-->
<!--        gInfiniteScroll-->
<!--        (infiniteScroll)="getNextPage()">-->
<!--        <mat-option class="multiline-mat-option">-->
<!--          <app-select-search-->
<!--            [formControl]="searchCtrl"-->
<!--            [disableScrollToActiveOnOptionsChanged]="true"-->
<!--            [noEntriesFoundLabel]="noEntriesFoundLabel"-->
<!--            [searching]="searching"-->
<!--            [hideClearSearchButton]="true">-->
<!--          </app-select-search>-->
<!--        </mat-option>-->

<!--        <mat-option value="">-&#45;&#45; Select -&#45;&#45;</mat-option>-->
<!--        <mat-option-->
<!--          *ngFor="let item of options | disableDuplicate:field.duplicateCheckKey | search: (field.filterKey || ''): filterVal"-->
<!--          (click)="onCountrySelect(item, focusable)"-->
<!--          [value]="item.optionValue"-->
<!--          [disabled]="item.disabled"-->
<!--          [ngClass]="{'multiline-mat-option':true,'danger': item.danger}">-->
<!--          {{ item.name | dynamicPipes: (field.dynamicPipes || [])}}-->
<!--        </mat-option>-->

<!--      </mat-select>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="flex flex-1">-->
<!--    <input type="tel"-->
<!--           class="p-3"-->
<!--           autocomplete="off"-->
<!--           matInput-->
<!--           (blur)="onTouched()"-->
<!--           (keypress)="onInputKeyPress($event)"-->
<!--           [(ngModel)]="phoneNumber"-->
<!--           (ngModelChange)="onPhoneNumberChange()"-->
<!--           [disabled]="disabled"-->
<!--           [placeholder]="field.placeholder"-->
<!--           #focusable>-->
<!--  </div>-->
<!--</div>-->

<div class="phone-input-field">
  <mat-form-field
    class="demo-full-width"
    appearance="outline"
  >
    <mat-label>{{field.label}}</mat-label>
    <input type="tel"
     autocomplete="off"
     matInput
     (blur)="onTouched()"
     (keypress)="onInputKeyPress($event)"
     (keyup)="onInputKeyPress($event)"
     [(ngModel)]="phoneNumber"
     (ngModelChange)="onPhoneNumberChange()"
     [disabled]="disabled"
     [placeholder]="field.placeholder"
     #focusable>
      <div class="w-[145px] hover:!bg-[#f3fbff]" matPrefix>
        <mat-select
          gInfiniteScroll
          [value]="selectedCountry"
          (infiniteScroll)="getNextPage()">
          <mat-option class="multiline-mat-option">
            <app-select-search
              [formControl]="searchCtrl"
              [disableScrollToActiveOnOptionsChanged]="true"
              [noEntriesFoundLabel]="noEntriesFoundLabel"
              [searching]="searching"
              [hideClearSearchButton]="true">
            </app-select-search>
          </mat-option>

          <mat-option value="">--- Select ---</mat-option>
          <mat-option
            *ngFor="let item of options | disableDuplicate:field.duplicateCheckKey | search: (field.filterKey || ''): filterVal"
            (click)="onCountrySelect(item, focusable)"
            [value]="item"
            [disabled]="item.disabled"
            [ngClass]="{'multiline-mat-option':true,'danger': item.danger}">
             {{ item.name | dynamicPipes: (field.dynamicPipes || [])}}
          </mat-option>

        </mat-select>
      </div>

  </mat-form-field>
</div>




